import { jsx as _jsx } from "react/jsx-runtime";
import cn from "../../../utils/cn";
const Thumb = ({ value, onKeyDownHandler, onMouseDownHandler, onTouchStart, min, max, isActive, percentageForValue }) => {
    return (_jsx("button", { type: "button", onKeyDown: onKeyDownHandler, onMouseDown: onMouseDownHandler, onTouchStart: onTouchStart, role: "slider", "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, className: cn("-translate-x-1/2 -translate-y-1/2 absolute top-1/2 h-5 w-5 rounded-full border border-gray-6 bg-white shadow-slider outline-none", isActive ? "z-20" : "z-30"), style: {
            left: `${percentageForValue}%`,
        } }, value));
};
export default Thumb;
